import React from 'react'
import { motion } from 'framer-motion'
import './Skills.css'

const Skills = () => {
  const skillCategories = [
    {
      title: 'Frontend',
      icon: '🎨',
      skills: [
        { name: 'React.js', level: 95, color: '#61dafb' },
        { name: 'Next.js', level: 90, color: '#000000' },
        { name: 'JavaScript', level: 95, color: '#f7df1e' },
        { name: 'HTML5 & CSS3', level: 95, color: '#e34f26' },
        { name: 'React Native', level: 85, color: '#61dafb' }
      ]
    },
    {
      title: 'Backend',
      icon: '⚙️',
      skills: [
        { name: 'Node.js', level: 90, color: '#339933' },
        { name: 'Express.js', level: 90, color: '#000000' },
        { name: 'MongoDB', level: 85, color: '#47a248' },
        { name: 'PHP', level: 80, color: '#777bb4' },
        { name: 'REST APIs', level: 90, color: '#ff6b6b' }
      ]
    },
    {
      title: 'Tools & Others',
      icon: '🛠️',
      skills: [
        { name: 'Git & GitHub', level: 90, color: '#f05032' },
        { name: 'Electron.js', level: 80, color: '#47848f' },
        { name: 'VS Code', level: 95, color: '#007acc' },
        { name: 'Figma', level: 75, color: '#f24e1e' },
        { name: 'Docker', level: 70, color: '#2496ed' }
      ]
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  }

  return (
    <section id="skills" className="skills section">
      <div className="container">
        <motion.div
          className="skills-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div className="skills-header" variants={itemVariants}>
            <span className="section-label">Skills</span>
            <h2 className="section-title">
              My <span className="text-gradient">Technical Arsenal</span>
            </h2>
            <p className="section-subtitle">
              A comprehensive toolkit of modern technologies and frameworks that I use to build
              exceptional digital experiences.
            </p>
          </motion.div>

          <div className="skills-grid">
            {skillCategories.map((category, categoryIndex) => (
              <motion.div
                key={categoryIndex}
                className="skill-category glass-card"
                variants={itemVariants}
              >
                <div className="category-header">
                  <span className="category-icon">{category.icon}</span>
                  <h3 className="category-title">{category.title}</h3>
                </div>
                <div className="skills-list">
                  {category.skills.map((skill, skillIndex) => (
                    <motion.div
                      key={skillIndex}
                      className="skill-item"
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ delay: skillIndex * 0.1 }}
                      viewport={{ once: true }}
                    >
                      <div className="skill-info">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percentage">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <motion.div
                          className="skill-progress"
                          initial={{ width: 0 }}
                          whileInView={{ width: `${skill.level}%` }}
                          transition={{ duration: 1, delay: 0.5 + skillIndex * 0.1 }}
                          viewport={{ once: true }}
                          style={{
                            background: `linear-gradient(90deg, ${skill.color}88, ${skill.color})`
                          }}
                        />
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div className="skills-technologies" variants={itemVariants}>
            <h3 className="technologies-title">Technologies I Work With</h3>
            <div className="technologies-grid">
              {[
                'React', 'Next.js', 'Node.js', 'Express', 'MongoDB',
                'JavaScript', 'TypeScript', 'HTML5', 'CSS3', 'Git',
                'GitHub', 'VS Code', 'Figma', 'Docker', 'AWS'
              ].map((tech, index) => (
                <motion.span
                  key={index}
                  className="technology-tag"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.05 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.1, y: -2 }}
                >
                  {tech}
                </motion.span>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default Skills
